

























































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import LinesManagerForm from './LinesManagerForm/LinesManagerForm.vue'
import LinesSouffling from './LinesSouffling/LinesSouffling.vue'
import LinesEquipment from './LinesEquipment/LinesEquipment.vue'


@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter', 'remains', 'workers',

      'document', 'meta'
    ]),
    ...mapGetters(STORE_KEY, [
      'hasActions', 'canActionToWork', 'canActionConfirmAction', 'disableActionConfirmActionCall', 'canActionToFormation',
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, ['toWork', 'toFormation', 'confirmBasket', 'loadRemains'])
  },
  components: {
    LinesManagerForm,
    LinesSouffling,
    LinesEquipment
  }
})
export default class LinesDetails extends Vue {

  @Prop() params!: any

  public TAB_VIEW_DETAILS = 0;
  public TAB_VIEW_FORM = 1;
  public TAB_VIEW_STATISTIC = 2;

  hActiveTab: number | null = null;

  get activeTab() {
    return this.hActiveTab ? this.hActiveTab : (this.isNew ? this.TAB_VIEW_FORM : this.TAB_VIEW_DETAILS);
  }

  set activeTab(value: number) {
    this.hActiveTab = value
  }

  public activeDetailTab = 0;

  get config() {
    return this.params || this.$route.params || {}
  }

  get isModal() {
    return this.params
  }

  get isNew() {
    return this.config.id == 'new'
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    console.log('details mounted', this.config)
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
  }

  @Watch('$route.params')
  public loadDocumentData(nV?: any, oV?: any) {
    if(!this.isModal || this.config.inline) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
    }
  }

  @Watch('config.id')
  public reloadDocumentData(nV?: any, oV?: any) {
    console.log('123')
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.config);
  }

  onNeedDataReload(documentId: string) {
    if (!this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        ...this.config,
        silence: true
      });
      this.hActiveTab = this.TAB_VIEW_DETAILS
    } else {
      this.$router.replace({
        name: 'lines-details',
        params: {
          id: documentId
        }
      })
    }
  }

  public goBack() {
    if (!this.params) {
      this.$router.push({ name: 'lines-manager' });
    } else {
      this.$router.back();
      this.$emit('close');
    }
  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }

}
